export function GetSubscriptionTier(subscriptionIndex) {
  switch (subscriptionIndex) {
    case 0:
      return "free";
    case 1:
      return "plus";
    case 2:
      return "pro";
  }
}
